import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the Canada production region (`enterprise.ca.wisesystems.io`)
 */
export const canadaServerConfig: ServerBaseUrl = {
    apiServer: 'https://api.ca.wisesys.info',
    auroraApiServer: 'https://aurora-v2.wisesys.info',
    equipment: 'https://services-production.us.wisesys.info',
    socketServer: 'wss://ca.socket.wisesys.info',
    equipmentSocketServer: 'wss://equipmentsocket.ca.wisesys.info',
    environment: ServerEnvironment.CANADA,
    CIEnv: ServerCIEnvironment.PRODUCTION,
    auroraServer: '',
    vehicleProfile:
        'https://ybtfow4mv3.execute-api.us-east-1.amazonaws.com/production',
    routePathGeometryServer:
        'https://ol1vgxgyob.execute-api.us-east-1.amazonaws.com/production',
    configurableWorkflowServer:
        'https://zcqwzh2eue.execute-api.us-east-1.amazonaws.com/Prod',
    driverCostServer:
        'https://lto7uvr6z9.execute-api.us-east-1.amazonaws.com/prod'
};
